import { computeNormalizedColorChannels } from 'src/helpers/colors';

export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const WHITE_RGB = computeNormalizedColorChannels(WHITE);
export const BLACK_RGB = computeNormalizedColorChannels(BLACK);
